import $ from "jquery";
import whatInput from "what-input";

window.$ = $;
window.jQuery = $;
window.whatInput = whatInput;

// ✅ Loads core + utils + all plugins (tabs, offcanvas, drilldown, etc.) in the right order
import "foundation-sites/dist/js/foundation.min.js";

// Your modules AFTER Foundation is loaded
import "./modules/AjaxPosts";
import "./modules/MegaMenu";
import "./modules/Newsletter";
import "./modules/Search";
import "./modules/SmoothScroll";
import "./modules/ViewSwitch";
import "./modules/Splide";
import "./modules/ObjectFitIE";
import CustomPdf from "./modules/CustomPdf";

document.addEventListener("DOMContentLoaded", () => {
  $(document).foundation();

  // Guard: don't crash pages without #offCanvas
  const offCanvas = document.getElementById("offCanvas");
  if (offCanvas) {
    const observer = new MutationObserver(() => {
      document.documentElement.classList.toggle(
        "is-off-canvas-open",
        offCanvas.classList.contains("is-open")
      );
    });
    observer.observe(offCanvas, { attributes: true, attributeFilter: ["class"] });
  }

  // Run after DOM + Foundation init
  new CustomPdf();
});